import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './types'
import JsBridge from '../plugins/jsBridge'
import { getUser } from '@/common/auth'
const bridge = new JsBridge()

Vue.use(Vuex)

// state
const state = {
  user: null,
  isLogin: false,
  appTheme: 0, // 1为黑夜模式，0位白天模式
  /** 是否为VIP用户 */
  isVip: false
}

// getters
const getters = {
  isLogin: state => state.isLogin,
  user: state => state.user
}

// mutations
const mutations = {
  SET_USER (state, user) {
    state.user = user
  },
  SET_ISLOGIN (state, boolean) {
    state.isLogin = boolean
  },
  SET_APP_THEME (state, val) {
    state.appTheme = val
  },
  [types.SET_VIP] (state, bool) {
    state.isVip = bool
  }
}

// actions
const actions = {
  getVipInfo({ commit }) {
    getUser({
      show: true,
      forceUpdate: true
    }).then((res) => {
      const {
        vip_level: vipLevel,
        vip_info: vipInfo,
      } = res;
      let isVip = false;
      if (vipLevel > 0 && !!vipInfo.ucenter_vip.is_vip) {
        isVip = true;
      }
      commit(types.SET_VIP, isVip);
    });
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions
})
export default store
